var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchloca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33331C6 7.86375 6.21071 8.37245 6.58579 8.74753C6.96086 9.1226 7.46957 9.33331 8 9.33331C8.53043 9.33331 9.03914 9.1226 9.41421 8.74753C9.78929 8.37245 10 7.86375 10 7.33331C10 6.80288 9.78929 6.29417 9.41421 5.9191C9.03914 5.54403 8.53043 5.33331 8 5.33331C7.46957 5.33331 6.96086 5.54403 6.58579 5.9191C6.21071 6.29417 6 6.80288 6 7.33331Z",
    stroke: "#828E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7717 11.1047L8.94299 13.9333C8.69298 14.1831 8.35405 14.3234 8.00066 14.3234C7.64727 14.3234 7.30834 14.1831 7.05833 13.9333L4.22899 11.1047C3.48314 10.3588 2.97522 9.40845 2.76945 8.3739C2.56369 7.33934 2.66932 6.267 3.073 5.29247C3.47667 4.31795 4.16026 3.48501 5.03732 2.89899C5.91437 2.31297 6.94551 2.00018 8.00033 2.00018C9.05515 2.00018 10.0863 2.31297 10.9633 2.89899C11.8404 3.48501 12.524 4.31795 12.9277 5.29247C13.3313 6.267 13.437 7.33934 13.2312 8.3739C13.0254 9.40845 12.5175 10.3588 11.7717 11.1047Z",
    stroke: "#828E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchloca);
export default __webpack_public_path__ + "static/media/searchloca.7946324467323858ff27afdce809939e.svg";
export { ForwardRef as ReactComponent };